import axios from 'axios';
const instance = axios.create({baseURL: 'https://api.bmw.mylotspy.com/api/v1'});
export default instance;
